import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type BreadcrumbNavigationState = {
    // Map of section name to array of paths
    sections: Record<string, string[]>;
};

const initialState: BreadcrumbNavigationState = {
    sections: {},
};

const breadcrumbSliceInternal = createSlice({
    name: 'breadcrumbNavigation',
    initialState,
    reducers: {
        addBreadcrumb: (state, action: PayloadAction<{ section: string; path: string }>) => {
            const { section, path } = action.payload;
            if (!state.sections[section]) {
                state.sections[section] = [];
            }
            state.sections[section].push(path);
        },
        removeBreadcrumb: (state, action: PayloadAction<{ section: string }>) => {
            const { section } = action.payload;
            if (state.sections[section] && state.sections[section].length > 0) {
                state.sections[section] = state.sections[section].slice(0, -1);
            }
        },
        replaceLastBreadcrumb: (state, action: PayloadAction<{ section: string; path: string }>) => {
            const { section, path } = action.payload;
            if (!state.sections[section] || state.sections[section].length === 0) {
                state.sections[section] = [path];
                return;
            }
            state.sections[section][state.sections[section].length - 1] = path;
        },
        setBreadcrumbs: (state, action: PayloadAction<{ section: string; paths: string[] }>) => {
            const { section, paths } = action.payload;
            state.sections[section] = [...paths];
        },
        clearBreadcrumbs: (state, action: PayloadAction<{ section: string }>) => {
            const { section } = action.payload;
            state.sections[section] = [];
        },
    },
});

export const breadcrumbNavigationSlice = breadcrumbSliceInternal;
export const breadcrumbNavigationActions = breadcrumbSliceInternal.actions;

const selectBreadcrumbNavigation = (state: { breadcrumbNavigation?: BreadcrumbNavigationState }) =>
    state.breadcrumbNavigation ?? initialState;

export const selectBreadcrumbs = (section: string) => (state: { breadcrumbNavigation?: BreadcrumbNavigationState }) =>
    selectBreadcrumbNavigation(state).sections[section] ?? [];
